import { Component } from '@angular/core';
import { ModalController, NavController, NavParams } from "ionic-angular";
import { HomePage } from "../../pages/home/home";
import { AngularFireDatabase } from "angularfire2/database";

/**
 * Generated class for the CustomepopupComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'customepopup',
  templateUrl: 'customepopup.html'
})
export class CustomepopupComponent {
  server: any;
  tableId: string;
  text: string;

  constructor(public modelCtrl: ModalController, public navParams: NavParams, public navCtrl: NavController, public af: AngularFireDatabase) {
    this.server = this.navParams.get('server');
    this.tableId = this.navParams.get('tableId');
    console.log(this.server);
  }

  connect() {
    
    let key = this.af.list('chekIds/').push({ isAvailable: true }).ref.key;
    let resturenData = this.navParams.get('resturenData');
    localStorage.setItem('server', JSON.stringify(this.server));
    localStorage.setItem('tableId', JSON.stringify(this.tableId));
    localStorage.setItem('connectedRestnt', JSON.stringify({ key: resturenData.key, name: resturenData.Address.res_name, chekId: key }));
    this.navCtrl.setRoot(HomePage, { server: this.server, resturenData: resturenData });
  }


  close() {
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/components/customepopup/customepopup.ts